import type { FC, ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

import { cn } from '@/shared/libs';

export interface ProviderFormGroupProps {
  children: ReactNode;
  onToggle: () => void;
  open: boolean;
  summary?: string;
  title: string;
}

export const ProviderFormGroup: FC<ProviderFormGroupProps> = ({
  children,
  onToggle,
  open,
  summary,
  title,
}) => (
  <section className="rounded-xl border border-border/40 bg-background/40">
    <button
      className="flex w-full cursor-pointer items-start justify-between gap-2 px-3 py-2.5 text-left"
      type="button"
      onClick={onToggle}>
      <span className="text-[11px] font-semibold tracking-wider text-muted-foreground uppercase">
        {title}
      </span>
      <span className="mt-0.5 flex shrink-0 items-center gap-2">
        {!open && !!summary && (
          <span className="hidden max-w-[180px] truncate text-xs text-muted-foreground sm:block">
            {summary}
          </span>
        )}
        <ChevronDown
          className={cn(
            'h-4 w-4 text-muted-foreground transition-transform',
            !open && '-rotate-90',
          )}
        />
      </span>
    </button>
    {open && (
      <div className="space-y-3 border-t border-border/40 px-3 pt-3 pb-3">
        {children}
      </div>
    )}
  </section>
);

ProviderFormGroup.displayName = 'ProviderFormGroup';
